import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import apm, { initializeApm } from '@/utils/apm';
import { useAuth } from '@/context/AuthContext'; // Adjust the import based on your actual auth context path

interface ApmProviderProps {
  children: React.ReactNode;
}

const ApmProvider: React.FC<ApmProviderProps> = ({ children }) => {
  const location = useLocation();
  // Assuming you have an auth context, adjust as needed
  const auth = useAuth();
  
  useEffect(() => {
    const serviceName = import.meta.env.VITE_APM_SERVICE_NAME as string;
    const serverUrl = import.meta.env.VITE_APM_SERVER_URL as string;
    const environment = import.meta.env.VITE_APM_ENVIRONMENT as string;
    const version = import.meta.env.VITE_VERSION as string || '';
    
    if (serviceName && serverUrl && environment) {
      initializeApm(serviceName, serverUrl, environment, version);
    } else {
      console.warn('APM configuration is incomplete. APM will not be initialized.');
    }
  }, []);
  
  // Set user context when user changes
  useEffect(() => {
    if (auth?.user?.id) {
      apm.setUserContext(auth.user.id, auth.user.username, auth.user.email);
    }
  }, [auth?.user]);
  
  // Create a transaction for each route change
  useEffect(() => {
    const path = location.pathname + location.search;
    const transaction = apm.startTransaction(`Route: ${path}`, 'route-change');
    
    return () => {
      // End the transaction when the component unmounts or route changes
      transaction?.end();
    };
  }, [location]);
  
  return <>{children}</>;
};

export default ApmProvider; 